import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";

import axios from "@/configs/axios";

interface DeleteSummaryResult {
  data: any;
  status: number;
}

export const usePostDeleteSummary = (): UseMutationResult<
  DeleteSummaryResult,
  Error,
  string,
  unknown
> => {
  const callDeleteSummary = useCallback(async (request: string): Promise<DeleteSummaryResult> => {
    try {
      const url = `${process.env.REACT_APP_SERVER_HOST}/delete_summary`;
      const response = await axios.post(url, { blob_name: request });
      return response;
    } catch {
      return { status: 500, data: [] };
    }
  }, []);

  return useMutation<DeleteSummaryResult, Error, string, unknown>({
    mutationFn: callDeleteSummary,
  });
};
